// extracted by mini-css-extract-plugin
export default {"indexSortWrapper":"IndexSort-module__indexSortWrapper--JOmD6"};